import createIcon from '../../createIcon';

/**
 * @component @name TextFormat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxNy41VjE5LjVIMTlWMTcuNUg1Wk05LjUgMTMuM0gxNC41TDE1LjQgMTUuNUgxNy41TDEyLjc1IDQuNUgxMS4yNUw2LjUgMTUuNUg4LjZMOS41IDEzLjNaTTEyIDYuNDhMMTMuODcgMTEuNUgxMC4xM0wxMiA2LjQ4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextFormat = createIcon('TextFormat', [
  [
    'path',
    {
      d: 'M5 17.5V19.5H19V17.5H5ZM9.5 13.3H14.5L15.4 15.5H17.5L12.75 4.5H11.25L6.5 15.5H8.6L9.5 13.3ZM12 6.48L13.87 11.5H10.13L12 6.48Z',
      key: '48qnm4',
    },
  ],
]);

export default TextFormat;
